import AbstractView from 'abstracts/AbstractView';
import Main from 'controllers/Main';
import Scroll from 'controllers/Scroll';
import Screen from 'controllers/Screen';
import TransitionController from 'controllers/TransitionController';
import Easing from 'utils/Easing';

export default class BigTitle extends AbstractView {
	constructor( $wrapper ) {
		super();
		this.$wrapper = $wrapper;
		this.mult = 1.5;
		this.isShown = false;
		this.init();
	}

	initDOM() {
		this.$pageContainer = this.$wrapper.closest( '.page_container' );
		this.$title = this.$wrapper.find( '.page_intro' );
		this.$inner = this.$wrapper.find( '.page_intro-inner' );
	}

	initEl() {
		this.red = this.$pageContainer.attr( 'data-color-r' ) ? parseInt( this.$pageContainer.attr( 'data-color-r' ) ) : 43;
		this.green = this.$pageContainer.attr( 'data-color-g' ) ? parseInt( this.$pageContainer.attr( 'data-color-g' ) ) : 43;
		this.blue = this.$pageContainer.attr( 'data-color-b' ) ? parseInt( this.$pageContainer.attr( 'data-color-b' ) ) : 226;
		this.splitTitle = new SplitText( this.$title, {
			type: 'lines',
			linesClass: 'transition-line',
		} );
		gsap.set( this.splitTitle.lines, {
			y: 100,
			opacity: 0,
		} );

	}

	bindEvents() {
		Main.on( Main.E.RAF, this.raf, this );
		TransitionController.on( TransitionController.E.TRANSITION_COMPLETE, this.show, this );
	}

	unbindEvents() {
		Main.off( Main.E.RAF, this.raf, this );
		TransitionController.off( TransitionController.E.TRANSITION_COMPLETE, this.show, this );
		super.bindEvents();
	}

	show( isFirstLoad ) {
		const delay = this.splitTitle.lines.length * 0.1 + 0.5;
		this.tw.show = gsap.timeline()
			.add( () => {
				$( this.splitTitle.lines ).addClass( 'intro' );
			} )
			.set( this.splitTitle.lines, {
				ease: 'power3.out',
				opacity: 1,
				y: 0,
				clearProps: 'all',
				delay: isFirstLoad ? 1 : 0,
			} )
			.add( () => {
				$( this.splitTitle.lines ).removeClass( 'intro' );
				this.isShown = true;
			}, '+=' + delay );
	}

	raf() {
		if ( ! this.isShown ) {
			return;
		}
		const percent = Scroll.yI / Screen.wH;
		if ( percent >= 0 && percent < this.mult ) {

			// TRANSFORM
			const transformY = -( Easing.linear( percent ) * ( Screen.wH * 0.2 ) ).toFixed( 3 ),
				transformZ = -( Easing.linear( percent ) * ( Screen.wH * 0.1 ) ).toFixed( 3 );
			// this.$inner[0].style.setProperty('transform', 'translateY(' + transform + 'px)');
			for ( let i = 0; i < this.splitTitle.lines.length; i++ ) {
				this.splitTitle.lines[ i ].style.setProperty( 'transform', ' translateY(' + ( transformY * ( 1 - i / 3 ) ) + 'px) translateZ(' + ( transformZ * ( 1 - i / 3 ) ) + 'px)' );
			}

			// COLOR
			const colorR = 255 + ( Easing.easeOutQuint( percent / this.mult ) * ( this.red - 255 ) ),
				colorG = 255 + ( Easing.easeOutQuint( percent / this.mult ) * ( this.green - 255 ) ),
				colorB = 255 + ( Easing.easeOutQuint( percent / this.mult ) * ( this.blue - 255 ) );
			this.$title[ 0 ].style.setProperty( 'color', 'rgb(' + colorR + ',' + colorG + ',' + colorB + ')' );

			// FONT WEIGHT
			// this.$title[0].style.setProperty('font-weight', 400 - Math.round(Easing.linear(percent / this.mult) * 300));

			const opacity = ( 1 - Easing.easeInOutQuint( percent / this.mult ) ).toFixed( 3 );
			this.$title[ 0 ].style.setProperty( 'opacity', opacity );

		}
	}

}
